import React from "react";
import { SafetyCertificateFilled, ShopFilled } from "@ant-design/icons";
import "Common/hooks/StyleFeatures/global.scss"
import ManagerLandingPage from "PlatForms/OrgLMS/Dashboards/Manager/LandingPage/ManagerLandingPage";
import NewEmployees from "PlatForms/OrgLMS/Dashboards/Manager/NewEmployees/index";
import { BookOnline, People } from "@mui/icons-material";
import TrainingCertificates from "PlatForms/OrgLMS/Dashboards/Admin/TrainingCertificate/TrainingCertificates";
import EmployeeGroup from "PlatForms/OrgLMS/Dashboards/Manager/EmployeeGroup/EmployeeGroup";
import TrainingRequestList from "PlatForms/OrgLMS/Dashboards/Manager/EmployeeGroup/TrainingRequest";
import ProtectedPage from "Common/Components/ProtectedPage";



const routes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "manager-dashboard",
    route: "/manager-dashboard",
    icon: <ShopFilled size="12px" />,
    component: (
      <ProtectedPage navigateTo="/manager-profile">
        <ManagerLandingPage />
      </ProtectedPage>
    ),
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Employees-Group",
    key: "employees",
    route: "/employees",
    icon: <People size="12px" />,
    component: (
      <ProtectedPage navigateTo="/manager-profile">
        <EmployeeGroup />
      </ProtectedPage>
    ),
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "New Employees",
    key: "new-employees",
    route: "/new-employees",
    icon: <People size="12px" />,
    component: (
      <ProtectedPage navigateTo="/manager-profile">
        <NewEmployees />
      </ProtectedPage>
    ),
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Training Certificate",
    key: "training-certificate",
    route: "/training-certificate",
    icon: <SafetyCertificateFilled size="12px" />,
    component: (
      <ProtectedPage navigateTo="/manager-profile">
        <TrainingCertificates />
      </ProtectedPage>
    ),
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Training Request",
    key: "training-request",
    route: "/training-request",
    icon: <BookOnline size="12px" />,
    component: (
      <ProtectedPage navigateTo="/manager-profile">
        <TrainingRequestList />
      </ProtectedPage>
    ),
    noCollapse: true,
  },

];

export default routes;
